import { FC } from 'react';
import { IHeaderCellWithFilterProps } from './interfaces';
import './HeaderCellWithFilter.scss';

export const HeaderCellWithFilter: FC<IHeaderCellWithFilterProps> = (props) => {
    const { icon: Icon, onClick, title } = props;

    return (
        <div
            className='header-cell-with-filter'
            onClick={onClick}
        >
            <span>{title}</span>
            {Icon && <Icon />}
        </div>
    );
};
